import $ from 'jquery';
import { extend } from 'underscore';

export default function (conf) {
    const $el = $(conf.query);
    $el.each(function () {
        extend(this, conf);
        if (typeof this.createdCallback === 'function') {
            this.createdCallback();
        }
        if (typeof this.attachedCallback === 'function') {
            this.attachedCallback();
        }
    });
    return $el;
}
